import { VolleyballGame } from '../types/games_api_types';
import React, { useState, useEffect, useCallback } from 'react';
import classes from './VolleyballGameControl.module.css';
import GameScorecard from '../game/GameScorecard';

export default function VolleyballGameControl({ uid }: { uid: string }) {
  const [game, setGame] = useState<VolleyballGame | null>(null);

  useEffect(() => {
    const loadGame = async () => {
      const response = await fetch(`/admin/volleyball/games/${uid}.json`);
      setGame(await response.json());
    };

    loadGame();
  }, []);

  const startGame = useCallback(async () => {
    const response = await fetch(`/admin/volleyball/games/${uid}/start.json`, {
      method: 'POST',
    });
    setGame(await response.json());
  }, []);

  const updateScore = useCallback(async (away: number, home: number) => {
    const response = await fetch(
      `/admin/volleyball/games/${uid}/update_score.json`,
      {
        method: 'POST',
        body: JSON.stringify({
          away: away,
          home: home,
        }),
      },
    );
    setGame(await response.json());
  }, []);

  if (game === null) {
    return null;
  }
  const lastNonNull = (arr?: Array<number | null>) => {
    if (!arr || arr.length === 0) return 0;
    for (let i = arr.length - 1; i >= 0; i--) {
      const v = arr[i];
      if (v !== null && v !== undefined) return v;
    }
    return 0;
  };

  const away_latest_period_score = lastNonNull(game.away_score_array);
  const home_latest_period_score = lastNonNull(game.home_score_array);

  return (
    <>
      <div className="tray" style={{ marginBottom: 25 }}>
        <div className="inner-tray">
          <GameScorecard game={game} />
        </div>
      </div>
      <div className={classes.controlCenter}>
        {game.last_tracked_at !== null && (
          <div className={classes.lastTracked}>
            Last Tracked:{' '}
            {new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            }).format(new Date(game.last_tracked_at * 1000))}
          </div>
        )}

        <div className={classes.scoreKeeper}>
          {game.state == 'upcoming' && (
            <button
              className="btn btn-success btn-lg"
              onClick={() => {
                startGame();
              }}
            >
              Start
            </button>
          )}

          {game.state === 'in_progress' && (
            <>
              <h2 className={classes.teamName}>{game.away_team}</h2>
              <div className={classes.scoreControl}>
                <div className={classes.scoreBox}>
                  {away_latest_period_score}
                </div>
                <div className={classes.buttons}>
                  <button
                    className={classes.upButton}
                    onClick={() =>
                      updateScore(
                        away_latest_period_score + 1,
                        home_latest_period_score,
                      )
                    }
                  >
                    <i className="fas fa-arrow-up"></i>
                  </button>
                  <button
                    className={classes.downButton}
                    onClick={() =>
                      updateScore(
                        away_latest_period_score - 1,
                        home_latest_period_score,
                      )
                    }
                  >
                    <i className="fas fa-arrow-down"></i>
                  </button>
                </div>
              </div>
              <div className={classes.scoreControl}>
                <div className={classes.scoreBox}>
                  {home_latest_period_score}
                </div>
                <div className={classes.buttons}>
                  <button
                    className={classes.upButton}
                    onClick={() =>
                      updateScore(
                        away_latest_period_score,
                        home_latest_period_score + 1,
                      )
                    }
                  >
                    <i className="fas fa-arrow-up"></i>
                  </button>
                  <button
                    className={classes.downButton}
                    onClick={() =>
                      updateScore(
                        away_latest_period_score,
                        home_latest_period_score - 1,
                      )
                    }
                  >
                    <i className="fas fa-arrow-down"></i>
                  </button>
                </div>
              </div>
              <h2 className={classes.teamName}>{game.home_team}</h2>
            </>
          )}

          {game.state === 'finished' && (
            <h2 className={classes.teamName}>Game Finished</h2>
          )}
        </div>
      </div>
    </>
  );
}
